// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"236":"85d4c6e5","561":"8ec6c802","830":"fb3cc5cb","896":"f738a78c","926":"f365e2c2","964":"e0b307ba"}[chunkId] + ".css";
};